/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { supportedLanguages } from '../../../utils/Locale';
declare let adobeIMS: AdobeIMS;

class AppsUtils {
	/**
	 * [getIMSData consolidates the IMS data for the current user that is passed to the view]
	 * @return {Object} object containing IMS data for the current user
	 */
	getIMSData() {
		if (window.adobeIMS) {
			const imsUserProfile = adobeIMS.getUserProfile();
			let userId;
			if (imsUserProfile) {
				userId = imsUserProfile?.authId || imsUserProfile?.userId;
			}
			const imsData = {
				token: adobeIMS.getAccessToken(),
				name: imsUserProfile ? imsUserProfile.first_name : null,
				email: imsUserProfile ? imsUserProfile.email : null,
				isSignedUser: Boolean(adobeIMS.isSignedInUser(false)),
				userId: imsUserProfile ? userId : null,
			};
			return imsData;
		}
		return {};
	}

	hideTransitionLoader() {
		document.getElementsByTagName('body')[0].classList.remove('bodyOverflowHidden');

		const transitionLoader = document.querySelector('.transition-screen-wrapper.apps') as HTMLElement;
		if (transitionLoader) {
			transitionLoader.style.display = 'none';
		}
	}

	removeClass(elem: HTMLElement | Node, classname: string) {
		const regex = new RegExp(`\\b${classname}\\b`, 'g');
		//@ts-ignore
		if (elem && elem.className) {
			//@ts-ignore
			elem.className = elem.className.replace(regex, '');
		}
	}

	getPathData() {
		const path = window.location.pathname.split('/');
		if (supportedLanguages.indexOf(path[1]) > -1) {
			return {
				page: path[2],
				mainTab: path[3],
				productId: path[4],
				pageType: path[5],
			};
		}
		return {
			page: path[1],
			mainTab: path[2],
			productId: path[3],
			pageType: path[4],
		};
	}
}

export default new AppsUtils();
